/*
 * Copyright (c) 2019 Apricad LLC. All Rights Reserved.
 */

import { combineReducers } from "redux";

import { userReducer, UserState } from "./userReducer";
import { courseReducer, CourseState } from "./courseReducer";
import { infoboxReducer, InfoBoxState } from "./infoboxReducer";
import { noteReducer, NotesState } from "./noteReducer";
// import { orderReducer, OrderState } from "./orderReducer";
import { ownReducer, OwnState } from "./ownReducer";
import { studyReducer, StudyState } from "./studyReducer";
import { postReducer, PostsState } from "./postReducer";
import { modalReducer, ModalState } from "./modalReducer";
import { secReducer, SecState } from "./secReducer";

export type ApricotState = {
  state_auth: UserState;
  state_course: CourseState;
  state_own: OwnState;
  state_study: StudyState;
  state_infobox: InfoBoxState;
  state_notes: NotesState;
  state_posts: PostsState;
  state_modal: ModalState;
  state_sec: SecState;
};

const rootReducers = combineReducers<ApricotState>({
  state_auth: userReducer,
  state_course: courseReducer,
  state_own: ownReducer,
  state_study: studyReducer,
  state_infobox: infoboxReducer,
  state_notes: noteReducer,
  state_posts: postReducer,
  state_modal: modalReducer,
  state_sec: secReducer,
});

// Public Selectors
// export function getCurrentCourse(store) {
//   const { courses, currentCourseId } = store.courseX;
// }

export default rootReducers;
